import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CheckboxVisibility,
  DefaultButton,
  DetailsList,
  Dropdown,
  IColumn,
  Modal,
  PrimaryButton,
} from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
import { NoDataFound } from '../../../../control/noDataFound';
export interface ModalProps {
  IsOpen: boolean;
  ProductId: number;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item: Api.ProductSpecificationResponseModel[];
  IsOverride?: boolean;
}
const ProductApi = new Api.ProductsApi();

const ModaProductSpecification = ({ Item, ProductId, IsOpen, onCloseModal, onSaveClick, IsOverride }: ModalProps) => {
  const { t } = useTranslation();
  const [isShow, SetIsShow] = React.useState(IsOpen);
  const [specifications, setSpecifications] = React.useState<Api.ProductSpecificationResponseModel[]>(Item);
  const [data, setData] = React.useState<Api.ProductSpecificationModel>({ProductId: ProductId});
  const { setToastData } = React.useContext(ToastAppMsgContext);

  const dropdownlistData = (brands: any[], textDefault: string) => {
    let result: any[] = [];
    if(textDefault)
      result.push({ key: 0, text: textDefault });
    brands?.forEach((element) => {
      result.push({ key: element.Id, text: element.Name });
    });
    if(!result.length)
      result.push({ key: null, text: t('NoDataFound'), disabled: true});
    return result;
  }

  const _columns = [
    {
      key: 'Component',
      name: t('Component'),
      fieldName: 'ComponentName',
      className: 'flex-center',
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: 'ComponentBrand',
      name: t('Brand'),
      className: 'flex-center',
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: Api.ProductSpecificationResponseModel) => {
        return (
          <Dropdown
            styles={{ root: { width: '100%' } }}
            options={dropdownlistData(item.Brands ?? [], t('AllBrands'))}
            selectedKey={item?.CBrandId}
            onChange={(e, opt, index) => {
              const row = specifications.findIndex((c) => c === item);
              specifications[row].CBrandId = opt?.key as number;
              specifications[row].CModelId = 0;
              setSpecifications([...specifications]);
            }}
          ></Dropdown>
        );
      },
    },
    {
      key: 'ComponentModel',
      name: t('Model'),
      className: 'flex-center',
      isResizable: true,
      onRender: (item: Api.ProductSpecificationResponseModel) => {
        return (
          <Dropdown
            placeholder={t('Select')}
            styles={{ root: { width: '100%' } }}
            options={dropdownlistData(item.Models?.filter((c) => item.CBrandId === 0 || c.CBrandId === item.CBrandId) ?? [], '')}
            selectedKey={item?.CModelId}
            onChange={(e, opt, index) => {
              const row = specifications.findIndex((c) => c === item);
              specifications[row].CModelId = opt?.key as number;
              setSpecifications([...specifications]);
            }}
          ></Dropdown>
        );
      },
    },
  ] as IColumn[];
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  
  const onSave = async () => {
    const modelIds = specifications
      .filter((o) => o.CModelId ?? 0 > 0)
      .map((o) => {
        return o.CModelId || 0;
      });
    data.ModelIds = modelIds;
    data.IsOverride = IsOverride ?? false;
    var result = await ProductApi.updateProductSpecification(data);
    if (!result || result.status !== 200) return;
    setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
    onCloseModal();
    SetIsShow(false);
    if (onSaveClick) {
      onSaveClick();
    }
  };
  
  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={t('EditProductSpecification')}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
      <DetailsList items={specifications} columns={_columns} checkboxVisibility={CheckboxVisibility.hidden} />
      <NoDataFound isShow={(specifications?.length || 0) === 0}></NoDataFound>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModaProductSpecification;